module.exports = polyvObject;


//////////////////
// WEBPACK FOOTER
// external "polyvObject"
// module id = qYsu
// module chunks = 1